import React from 'react'
import _ from 'lodash'

/*
  required props:
    errors
  
  At least one of these props:
    handleAutoSync
    handleAutoSyncOnBlur
    handleAutoSyncOnChange
    updatePortalAtPath
*/
const withValidateBeforeSync = options => WrappedComponent => {
  return class ValidateBeforeSync extends React.Component {
    componentWillMount() {
      if (this.props.validateForm) this.props.validateForm()
    }

    validate = (name, value) => {
      let values = {
        ...this.props.values,
        [name]: value
      }
      console.log("->", name, value)
      let errors = options.validate(values, this.props)
      return _.isEmpty(_.get(errors, name))
    }

    handleAutoSync = (name, value) => {
      if (this.validate(name, value) && this.props.handleAutoSync) {
        this.props.handleAutoSync(name, value)
      }
    }
    handleAutoSyncOnBlur = e => {
      if (this.validate(e.target.name, e.target.value) && this.props.handleAutoSyncOnBlur) {
        this.props.handleAutoSyncOnBlur(e)
      }
    }
    handleAutoSyncOnChange = e => {
      if (this.validate(e.target.name, e.target.value) && this.props.handleAutoSyncOnChange) {
        this.props.handleAutoSyncOnChange(e)
      }
    }
    updatePortalAtPath = (path, values) => {
      if (this.validate(path, values) && this.props.updatePortalAtPath) {
        this.props.updatePortalAtPath(path, values)
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleAutoSync={this.handleAutoSync}
          handleAutoSyncOnBlur={this.handleAutoSyncOnBlur}
          handleAutoSyncOnChange={this.handleAutoSyncOnChange}
          updatePortalAtPath={this.updatePortalAtPath}
        />
      )
    }
  }
}
export default withValidateBeforeSync



// WEBPACK FOOTER //
// ./src/modules/common/withValidateBeforeSync.js